import React from 'react';
import useReveal from '../hooks/useReveal';
import './Reveal.css';

// Wraps children and fades/slides them up when scrolled into view.
// `delay` (ms) staggers groups of items revealed together.
const Reveal = ({ children, delay = 0, className = '', as: Tag = 'div' }) => {
  const [ref, visible] = useReveal();

  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? 'reveal-visible' : ''} ${className}`.trim()}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
